import yup from 'yup'
import { setLocale } from 'yup/lib/customLocale'
import {
  formatMm,
  formatKNm2
} from '../../../location_changes/conversionHelper'

setLocale({
  mixed: {
    default: 'Value is invalid',
    required: 'Value is required',
    oneOf: 'Must be one of the following values: ${values}',
    notOneOf: 'Must not be one of the following values: ${values}',
    notType: _ref => 'Must be a ' + _ref.type
  },
  string: {
    length: 'Must be exactly ${length} characters',
    min: 'Must be at least ${min} characters',
    max: 'Must be at most ${max} characters',
    matches: 'Must match the following: "${regex}"',
    email: 'Must be a valid email',
    url: 'Must be a valid URL',
    trim: 'Must be a trimmed string',
    lowercase: 'Must be a lowercase string',
    uppercase: 'Must be a upper case string'
  },
  number: {
    min: 'Must be greater than or equal to ${min}',
    max: 'Must be less than or equal to ${max}',
    positive: 'Must be a positive number',
    negative: 'Must be a negative number',
    integer: 'Must be an integer'
  },
  date: {
    min: 'Field must be later than ${min}',
    max: 'Field must be at earlier than ${max}'
  },
  object: {
    noUnknown: 'Field cannot have keys not specified in the object shape'
  },
  array: {
    min: 'Field must have at least ${min} items',
    max: 'Field must have less than ${max} items'
  }
})

export const SlabSchema = yup.object().shape({
  type: yup.string().required(),
  model: yup.string().required(),
  height: yup.number(),
  span: yup.lazy(() => {
    return (
      yup
        .number()
        .required()
        // In future, this should be a dynamic value. The minimum span is 900mm + distance from the
        // beam centre line to the beginning of the slab.
        .min(1000, 'Must be greater than or equal to ' + formatMm(1000))
        .max(18000, 'Must be less than or equal to ' + formatMm(18000))
        .integer()
    )
  }),
  weight: yup.lazy(() => {
    return yup
      .number()
      .required()
      .min(0.1, 'Must be greater than or equal to ' + formatKNm2(0.1))
      .max(500, 'Must be less than or equal to ' + formatKNm2(500))
  }),
  topConcrete: yup.lazy(() => {
    return yup
      .number()
      .min(0, 'Must be greater than or equal to ' + formatMm(0))
      .max(200, 'Must be less than or equal to ' + formatMm(200))
  })
})

export const LoadCaseLoadSchema = yup.object().shape({
  name: yup
    .string()
    .min(2)
    .required(),
  type: yup.string().required(),
  values: yup
    .array()
    .of(
      yup
        .array()
        .test('load-value', 'Invalid load value', val => {
          // We expect load values to be [location, value]
          if (val.length !== 2) {
            return false
          }

          if (val[0] === null || val[1] === null || val[1] === '') {
            return false
          }

          if (val[0] < 0) {
            return false
          }

          if (isNaN(val[1]) || val[1] > 500 || val[1] < -500) {
            return false
          }

          return true
        })

        .min(2)
    )
    .min(1)
})

export const LoadCaseSchema = yup
  .object()
  .shape({
    name: yup
      .string()
      .required()
      .min(2),
    action: yup.string().required(),
    // Loads are [[ pos, value ], [ ... ]], i.e. pairs of position and value
    loads: yup
      .array()
      .of(LoadCaseLoadSchema)
      .required()
      .min(1)
  })
  .required()

export const BeamSchema = yup.object().shape({
  type: yup.string().required(),
  length: yup.lazy(() => {
    return yup
      .number()
      .min(500, 'Must be greater than or equal to ' + formatMm(500))
      .max(12000, 'Must be less than or equal to ' + formatMm(12000))
      .required()
      .integer()
  }),
  concreteGrade: yup.string().required()
})

export const schema = yup.object().shape({
  beam: BeamSchema,
  slab: yup
    .object()
    .shape({
      left: SlabSchema,
      right: SlabSchema
    })
    .required(),
  loadStages: yup
    .object()
    .shape({
      erection: yup
        .array()
        .of(LoadCaseSchema)
        .required(),
      finalComposite: yup
        .array()
        .of(LoadCaseSchema)
        .required()
    })
    .required()
})



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/validationSchema.ts